<template>
  <div
    tabindex="0"
    @keydown.ctrl.86.prevent.stop="ctrlV"
    @keydown.ctrl.67.prevent.stop="ctrlC"
    @keydown.ctrl.90.prevent.stop.exact="ctrlZ"
    @keydown.ctrl.shift.90.prevent.stop="ctrlShiftZ"
  >
    <AIoTHeader
      @saveClick="saveData"
      @clearClick="clearAllBtnWithConfirm"
      @loadFunction="loadProject"
      @logoutClick="logoutClick"
      curPage="chart"
    />
    <div class="mainDiv">
      <div class="toolsArea">
        <div class="toolBlock">
          <p>ToolBox</p>
          <div class="img_container">
            <img
              v-for="el in nodeDefinitions.toolBox"
              :key="el"
              :src="require(`@/assets/ChartDrop/${el}_view.png`)"
              @dragstart="dragImg(el)"
            />
          </div>
        </div>
        <div class="toolBlock">
          <p>Gadgets</p>
          <div class="img_container">
            <img
              v-for="el in nodeDefinitions.gadgets"
              :key="el"
              :src="require(`@/assets/ChartDrop/${el}_view.png`)"
              @dragstart="dragImg(el)"
            />
          </div>
        </div>
        <div class="toolBlock">
          <p>Trained Model</p>
          <div class="img_container">
            <div
              class="AIModel"
              draggable="true"
              v-for="(item, index) in Object.keys(exportKnnClassifiers)"
              :key="item"
              :title="item"
              @dragstart="dragImg('AIModels', item, index)"
            >
              <div class="block" :data-text="item"></div>
              <p>{{ item }}</p>
            </div>
          </div>
        </div>
        <div class="toolBlock">
          <div class="titleWithBtn">
            <span class="title">Actions</span>
            <span class="addBUtton" @click="addAction">
              <svg width="22" height="22" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11" r="11" fill="#9b9c9e" />
                <line
                  x1="11"
                  y1="5.5"
                  x2="11"
                  y2="16.5"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <line
                  x1="5.5"
                  y1="11"
                  x2="16.5"
                  y2="11"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <span>Code</span>
            </span>
            <span class="addBUtton" @click="addActions">
              <svg width="22" height="22" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11" r="11" fill="#2cb5e9" />
                <line
                  x1="11"
                  y1="5.5"
                  x2="11"
                  y2="16.5"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <line
                  x1="5.5"
                  y1="11"
                  x2="16.5"
                  y2="11"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <span>RAS</span>
            </span>
          </div>
          <div class="img_container">
            <div
              draggable="true"
              class="action"
              v-for="(item, index) in cacheDFDActions.actions"
              :key="index"
              @dragstart="dragImg('Actions', item, index)"
              :title="item.name"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="flowchartArea">
        <simple-flowchart
          ref="simpleFlowChart"
          :scene.sync="scene"
          @nodeClick="nodeClick"
          @nodeUnselected="nodeUnselected"
          @nodeDelete="nodeDelete"
          @linkBreak="linkBreak"
          @linkAdded="linkAdded"
          @canvasClick="canvasClick"
          @addNodeFromDrop="addNode"
          @nodeDbClick="openEditNodePanel"
          @changeOperator="changeInputCountByOperator"
          @copyNode="copyNode"
          :clearAll="clearAll"
          :ticktokControllerManager="ticktokControllerManager"
          :ticktokControllerPlay="ticktokControllerPlay"
          @resetClearAll="resetClearAll"
          @triggerController="triggerController"
          :height="837"
          :selectedNode="nodeSelected"
        />
      </div>
    </div>

    <div id="shadowMask" v-if="showShadowMask"></div>

    <div class="windowLoading" v-if="showShadowMask === 'window'">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <!-- controller open panel  "manager"-->
    <div
      class="editManagerPanel"
      v-else-if="showShadowMask === 'manager' || showShadowMask === 'play'"
    >
      <header>
        Robot Manager
        <img
          src="@/assets/icon/notice_close.png"
          v-if="showShadowMask === 'manager'"
          @click="closeShadowMask('manager')"
        />
        <img
          src="@/assets/icon/notice_close.png"
          v-if="showShadowMask === 'play'"
          @click="interruptBurning"
        />
      </header>
      <div class="content">
        <ul class="list-unstyled">
          <li
            v-for="(item, index) in connectedDevicesWithNickname"
            :class="{ error: item.confidence === -1 }"
            :key="index"
          >
            <h3>{{ item.name }}</h3>
            <img src="@/assets/icon/remote-controller/Group 443@2x.png" alt />

            <input
              type="text"
              :disabled="showShadowMask === 'play'"
              :value="item.nickName"
              @input="changeNickName(item, $event)"
            />

            <div class="progress w-100">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                :style="{
                  width: `${burnPercentage[item.name]}%`,
                  backgroundColor: '#37ccda'
                }"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <span
                  v-if="item.confidence === -1"
                  style="color:red;position:absolute; left:50%;transform:translateX(-50%)"
                  >Error</span
                >
              </div>
            </div>
          </li>
          <li v-for="n in 3 - connectionNumber" :key="`Holder${n}`">
            <h3>None</h3>
            <img src="@/assets/icon/remote-controller/Group 444@2x.png" alt />
            <input type="text" disabled="disabled" />
            <div class="progress w-100">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                :style="{ width: 0 + '%', backgroundColor: '#37ccda' }"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer"></div>
    </div>

    <div class="editNodePanel" v-else-if="showShadowMask === 'Counter'">
      <header>
        {{ "Counter" }}
        <img src="@/assets/icon/notice_close.png" @click="closeShadowMask" />
      </header>
      <div class="setting-container">
        <div class="setting-content">
          <span>Counter type:</span>

          <!-- 仿showzone -->
          <!-- 輸入部分 -->
          <div class="show-zone" @click="openDropDown">
            <span class="d-inline-block text-left">
              {{
                scene.nodes[settingNodeKey].styleClass.secondClass === "CounterUp" ? `Up` : `Down`
              }}
            </span>

            <!-- 箭頭部分 -->
            <div class="arrow"></div>
            <!-- 展開部分 -->
            <div class="expand-zone" v-show="showDropDown">
              <ul class="list-unstyled mb-0">
                <li
                  v-for="(item, index) in ['Up', 'Down']"
                  class="custom-option"
                  :key="index"
                  @click="changeCounterOption(`Counter${item}`)"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="editNodePanel" v-else-if="showShadowMask !== ''">
      <header>
        {{
          scene.nodes[settingNodeKey].styleClass.secondClass ||
            scene.nodes[settingNodeKey].styleClass.firstClass
        }}
        <img src="@/assets/icon/notice_close.png" @click="closeShadowMask" />
      </header>
      <div class="setting-container">
        <div class="setting-content">
          <span>Number of inputs</span>
          <img
            :src="require(`@/assets/icon/DFD/${canMinusNodeCount ?
            'ipt_minus_yes' : 'ipt_minus_no'}.png`)"
            @click="minusInputCount"
          />

          <input
            type="number"
            v-model.number="scene.nodes[settingNodeKey].properties.inputCount"
            :disabled="true"
          />
          <img
            :src="require(`@/assets/icon/DFD/${canPlusNodeCount ?
            'ipt_plus_yes' : 'ipt_plus_no'}.png`)"
            @click="plusInputCount"
          />
        </div>
      </div>
    </div>
    <input ref="input" type="file" style="display:none" @change="codeFileChange" />
    <input ref="inputs" type="file" style="display:none" @change="rasFlipChange" multiple />
    <LogoutPopup
      v-if="logoutPopup"
      @CancelClose="closeLogoutPopup"
      @logoutProcess="logoutProcess"
    />
    <ChartControl
      class="chartController"
      @zoomin="zoomin"
      @zoomout="zoomout"
      @undo="ctrlZ"
      @redo="ctrlShiftZ"
    />
  </div>
</template>

<script>
/* eslint-disable */
import AIoTHeader from "@/components/AIoTHeader.vue";
import SimpleFlowchart from "@/components/SimpleFlowchart.vue";
import LogoutPopup from "@/components/LogoutPopup.vue";
import ChartControl from "@/components/ChartControl.vue";
import { webBleMixin } from "@/assets/webBleMixin/webBleMixin.js";
import { graphMixin } from "@/assets/graphMixin/graphMixin.js";
import { codeGenerator } from "@/assets/codeGenerator/codeGenerator.js";
import { mapState, mapMutations, mapGetters } from "vuex";
import nodeDefinitions from "@/assets/nodeType.js";
import * as tf from "@tensorflow/tfjs";

import Swal from "sweetalert2";
const swalWithCustomClass = Swal.mixin({
  customClass: {
    container: "custom-confirm",
    confirmButton: "button-confirm",
    cancelButton: "button-cancel"
  },
  allowOutsideClick: false,
  buttonsStyling: false
});

export default {
  mixins: [graphMixin, codeGenerator, webBleMixin],
  name: "app",
  components: {
    SimpleFlowchart,
    AIoTHeader,
    LogoutPopup,
    ChartControl
  },
  data() {
    return {
      nodeDefinitions,
      scene: {
        centerX: 971,
        centerY: 727,
        transformX: 0,
        transformY: 0,
        scale: 1,
        nodes: {},

        links: []
      },
      nodeCopied: null,
      nodeSelected: [],
      newNodeType: "",
      newNodeIndex: 0,

      newNodeLabel: "",

      settingNodeKey: 0,
      showShadowMask: "",

      showDropDown: false,
      clearAll: false,
      ticktokControllerManager: 0,
      ticktokControllerPlay: 0,
      round: 1,
      stopManually: false,
      interrupter: false,
      mode: "",
      burnPercentage: {},
      bleNickName: {},
      waitCount: 0,
      waitInterval: null,
      newNodeKey: null,
      logoutPopup: false,

      history: [],
      preHistory: []
    };
  },

  computed: {
    ...mapState([
      "connectedDevices",
      "exportKnnClassifiers",
      "exportKnnDataSet",
      "classifiersForSave",
      "cacheDFDActions",
      "cacheDFD"
    ]),
    ...mapGetters(["connectedDevicesWithNickname", "connectionNumber"]),
    canMinusNodeCount() {
      // 大於最小值 可以減
      const theNode = this.scene.nodes[this.settingNodeKey];
      const { inputCount } = theNode.properties;
      let minInputCount = 0;

      if (theNode.styleClass.firstClass === "Constant") {
        minInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass]
          .special[0];
      } else {
        minInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass][
          theNode.styleClass.secondClass
        ][0];
      }

      return inputCount > minInputCount;
    },
    canPlusNodeCount() {
      // 小於最大值 可以加
      const theNode = this.scene.nodes[this.settingNodeKey];
      const { inputCount } = theNode.properties;
      let maxInputCount = 0;
      if (theNode.styleClass.firstClass === "Constant") {
        maxInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass]
          .special[1];
      } else {
        maxInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass][
          theNode.styleClass.secondClass
        ][1];

        // console.log("maxInputCount", maxInputCount);
      }
      return inputCount < maxInputCount;
    },
    cacheScene() {
      return JSON.stringify(this.scene);
    }
  },
  async mounted() {
     this.setCameraRef({
      cameraRef: this.$children[1].$refs.video,
      wifiCameraRef: this.$children[1].$refs.wifiVideo,
    });
    let vm = this;

    if (!this.mobilenet) {
      this.$store
        .dispatch("loadMobilenet")
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    }

    if (Object.keys(this.cacheDFDActions).length === 0) {
      if( window.localStorage.getItem('cacheActionsData')){
        this.cacheDFDActionsData(JSON.parse(window.localStorage.getItem('cacheActionsData')))
      }else{
        this.cacheDFDActionsData({
          actions: [],
          vars: [],
          hex: this.hexData,
          codeID: this.getCodeID()
        });
      }
    }
    console.log('mounted')
    if (this.cacheDFD) {
      console.log('here');
      this.scene = JSON.parse(this.cacheDFD);
    } else if(window.localStorage.getItem('cacheDFDData')){
      const tempDFD = JSON.parse(window.localStorage.getItem('cacheDFDData'));
      const aiNodes = [];
// delete this.scene.nodes[id];
      Object.keys(tempDFD.nodes).forEach(key => {
        if(tempDFD.nodes[key].type === 'AIModels'){
          aiNodes.push(key)
          delete tempDFD.nodes[key]
        }
      });
      
      tempDFD.links = tempDFD.links.filter(el => !aiNodes.includes(el.from) && !aiNodes.includes(el.to))
      console.log('or here', tempDFD)
      this.scene = tempDFD;
    }
    if (localStorage.getItem("token")) {
      this.loginToken(localStorage.getItem("token"));
    }
  },
  watch: {
    cacheScene: {
      handler(val, oldVal) {
        // console.log(oldVal);
        // console.log(val);

        const valParse = JSON.parse(val);
        const valNodes = valParse.nodes;
        const oldValParse = JSON.parse(oldVal);
        const oldValNodes = oldValParse.nodes;

        // properties異動 不存
        if (Object.keys(valNodes).length === Object.keys(oldValNodes).length) {
          let isValueSame = true;
          for (let i = 0; i < Object.keys(valNodes).length; i++) {
            const key = Object.keys(valNodes)[i];

            if (
              JSON.stringify(valNodes[key].properties.inputs) !==
                JSON.stringify(oldValNodes[key].properties.inputs) ||
              JSON.stringify(valNodes[key].properties.outputs) !==
                JSON.stringify(oldValNodes[key].properties.outputs)
            ) {
              isValueSame = false;
              break;
            }
          }

          if (!isValueSame) {
            console.log("這次是properties異動 不記快取");
            return;
          }
        }
        for (const nodeKey in valNodes) {
          const node = valNodes[nodeKey];
          console.log("紀錄");
          // 清除藍芽紀錄

          // if (node.properties.hasOwnProperty("gadgetsProp")) {
          //   node.properties.gadgetsProp.ble = {};
          // }
          // if (node.properties.hasOwnProperty("actionsProp")) {
          //   node.properties.actionsProp.ble = {};
          // }
          // 清除ai confidence
          if (node.properties.hasOwnProperty("aiProps")) {
            node.properties.aiProps.forEach(e => {
              e.confidence = 0;
            });
          }
        }
        this.cacheDFDData(JSON.stringify(valParse));
        // cache to localstorage
        window.localStorage.setItem("cacheDFDData", JSON.stringify(valParse));
        console.log("有記快取");
      },
      deep: true
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },
  methods: {
    ...mapMutations([
      "addNewClassifier",
      "loadClassifierNet",
      "cacheDFDActionsData",
      "cacheDFDData",
      "changeDeviceNickName",
      "loginToken",
      "logout",
      "setCameraRef"
    ]),
    preventNav(event) {
      // if (!this.isEditing) return
      // console.log(event)
      event.preventDefault();
      event.returnValue = "dscldsnclsdcnd";
      // return 'dsnclsncldnsclsd'
    },
    ctrlV() {
      console.log("ctrl + v  click");
      if (this.nodeCopied) {
        this.copyNode(this.scene.nodes[this.nodeCopied]);
      }
    },
    ctrlC() {
      console.log("ctrl + c  click");
      this.nodeCopied = this.nodeSelected[0];
    },
    ctrlZ() {
      console.log("ctrlZ");
      if (this.history.length) {
        const tmpScence = this.history.pop();
        // console.log(tmpScence);
        this.preHistory = [...this.preHistory, JSON.stringify(this.scene)];
        this.scene = JSON.parse(tmpScence);
        // this.scene = this.history.pop();
      }
    },
    ctrlShiftZ(e) {
      console.log("ctrlShiftZ");
      if (this.preHistory.length) {
        const tmpScence = this.preHistory.pop();
        console.log(tmpScence);
        this.history = [...this.history, JSON.stringify(this.scene)];
        this.scene = JSON.parse(tmpScence);
        // this.scene = this.history.pop();
      }
    },
    zoomin() {
      this.scene.scale = Math.min(this.scene.scale + 0.1, 2);
    },
    zoomout() {
      this.scene.scale = Math.max(this.scene.scale - 0.1, 0.3);
    },
    logoutClick() {
      console.log("log out click from chart");
      this.logoutPopup = true;
    },
    closeLogoutPopup() {
      this.logoutPopup = false;
    },
    closeCameraPopup() {
      this.cameraPopup = false;
    },
    logoutProcess() {
      this.logout();
      this.$router.replace({ path: "login" });
    },
    saveData() {
      swalWithCustomClass
        .fire({
          title: "Save",
          text: "Block diagram file name.",
          input: "text",
          inputAttributes: {
            autocapitalize: "off"
          },
          reverseButtons: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          showCloseButton: true,
          // eslint-disable-next-line consistent-return
          inputValidator: value => {
            if (!value) {
              return "You need to write something!";
            }
          }
        })
        .then(result => {
          console.log(result);
          if (result.isConfirmed) {
            let dataToSave = {};
            // prepare AI
            dataToSave["AiData"] = this.classifiersForSave;
            // prepare Actions
            dataToSave["ActionData"] = this.cacheDFDActions;
            // prepare node and link information
            dataToSave["NodeAndLinkData"] = this.scene;
            //save as json
            let data = JSON.stringify(dataToSave);
            const file = new Blob([data], { type: "application/json" });
            const a = document.createElement("a");
            a.href = URL.createObjectURL(file);
            a.download = `${result.value}.aiotChart`;
            a.click();
          }
        });
    },

    loadProject(result) {
      swalWithCustomClass
        .fire({
          title: "Load",
          text: "The existing block diagram will be overwritten. Are you sure to load the file?",
          reverseButtons: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          showCloseButton: true
        })
        .then(res => {
          console.log(result);
          if (res.isConfirmed) {
            // clear current nodes and links
            // set new nodes and links
            this.scene = result.NodeAndLinkData;
            // clear actions
            // set new actions, actions and hex
            this.cacheDFDActionsData({
              actions: result.ActionData.actions,
              vars: result.ActionData.vars,
              hex: result.ActionData.hex,
              codeID: result.ActionData.codeID
            });
            window.localStorage.setItem("cacheActionsData", JSON.stringify(this.cacheDFDActions));

            // claer AI models

            // set classifiers
            Object.entries(result.AiData).forEach(([key, value]) => {
              const sortedKeys = Object.keys(value.dataset).sort();
              const tensorsData = value.tensors
                .map((tensor, i) => {
                  if (tensor) {
                    const values = Object.keys(tensor).map(v => tensor[v]);
                    const key = sortedKeys[i];
                    return tf.tensor(values, value.dataset[key].shape, value.dataset[key].dtype);
                  }
                  return null;
                })
                .reduce((acc, cur, j) => {
                  // j means index
                  // set key like '0000001...'
                  const key = sortedKeys[j];
                  acc[key] = cur;
                  return acc;
                }, {});
              this.addNewClassifier({
                name: value.name,
                tensorsData,
                dataset: value.dataset,
                tensors: value.tensors
              });
            });
          }
        });
    },

    async execute() {
      // 第一輪才要
      if (this.round === 1) {
        this.stopManually = false;
      } else if (this.round > 1) {
        const delay = interval =>
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
            }, interval);
          });

        await delay(50);
      }
      // console.log(`excecute No.${this.round} round`);

      // get ai nodes
      const aiNodes = Object.keys(this.scene.nodes)
        .filter(key => {
          if (this.scene.nodes[key].styleClass.firstClass === "AIModels") {
            return true;
          }
          return false;
        })
        .map(id => {
          return this.scene.nodes[id];
        });
      const newAIValue = await this.aiProcess(aiNodes);
      console.log(newAIValue);
      for (const key in newAIValue) {
        // console.log(result.nodes.AIModelsBuffer);
        if (!this.scene.nodes.hasOwnProperty(key)) {
          // do nothing
        } else {
          for (const key2 in newAIValue[key]) {
            const arrayValue = Object.values(newAIValue[key]);
            this.scene.nodes[key].properties.aiProps.forEach((e, index) => {
              e.confidence = arrayValue[index];
            });
          }
        }
      }

      this.setGraph();

      const result = await this.bfs();

      console.log("bfsResult", result);
      for (const key in result.nodes.outputBuffer) {
        // ex:key = 1570525295470
        // console.log("!!!", key, this.scene.nodes[key]);
        if (!this.scene.nodes.hasOwnProperty(key)) {
          // do nothing
        } else {
          for (const key2 in result.nodes.outputBuffer[key]) {
            // ex:key2 =input1

            //! 如果 node是 gadgets or counter 要把output1回填 value
            if (
              this.scene.nodes[key].styleClass.firstClass === "Gadgets" ||
              this.scene.nodes[key].styleClass.firstClass === "Counter"
            ) {
              this.scene.nodes[key].properties.value = result.nodes.outputBuffer[key][key2];
            }
            this.scene.nodes[key].properties.outputs[key2] = result.nodes.outputBuffer[key][key2];
          }
        }
      }

      for (const key in result.nodes.inputBuffer) {
        if (!this.scene.nodes.hasOwnProperty(key)) {
          // do nothing
        } else {
          for (const key2 in result.nodes.inputBuffer[key]) {
            this.scene.nodes[key].properties.inputs[key2] = result.nodes.inputBuffer[key][key2];
          }
        }
      }

      for (const key in result.nodes.AIModelsBuffer) {
        // console.log(result.nodes.AIModelsBuffer);
        if (!this.scene.nodes.hasOwnProperty(key)) {
          // do nothing
        } else {
          for (const key2 in result.nodes.AIModelsBuffer[key]) {
            const arrayValue = Object.values(result.nodes.AIModelsBuffer[key]);
            this.scene.nodes[key].properties.aiProps.forEach((e, index) => {
              e.confidence = arrayValue[index];
            });
          }
        }
      }

      // console.log("nodes", this.scene.nodes);
      // || this.round === 5
      if (result.terminal || this.stopManually) {
        // 中止 loop
        this.stopExecute();
      } else {
        this.round++;
        this.execute();
      }
    },

    stopExecute() {
      this.ticktokControllerPlay++;
      this.round = 1;
    },
    dragImg(type, detail, index = 0) {
      if (type === "AIModels") {
        console.log(detail);
      } else if (type === "Actions") {
        console.log(detail.name);
      }
      this.newNodeType = type;
      this.newNodeKey = detail;
      this.newNodeIndex = index;
    },

    dataFormatter() {
      // 清空inputs
      for (const key in this.scene.nodes) {
        this.scene.nodes[key].properties.inputs = {};
      }
      // 寫入inputs
      this.scene.links.forEach(e => {
        this.scene.nodes[e.to].properties.inputs[e.portIndex] = {
          label: e.portIndex.toString()
        };
      });
    },
    setGraph() {
      const data = { vectexs: {} };
      data.vectexs = this.scene.nodes;

      // console.log("data", data);
      this.setData(data);
      for (const key in data.vectexs) {
        if (data.vectexs.hasOwnProperty(key)) {
          this.addVectex(key);
        }
      }
      this.scene.links.forEach(e => {
        const outputString = `output${e.portOutIndex + 1}`;
        this.addEdge(e.from, e.to, outputString, e.portIndex);
      });
    },
    canvasClick(e) {
      // console.log("canvas Click, event:", e);
    },
    copyNode(payload) {
      const maxID = Number(new Date().getTime());
      const template = JSON.parse(JSON.stringify(payload)) ;
      template.id = maxID;
      template.x = template.x + 50;
      template.y = template.y + 50;

      console.log(template);
      this.history = [...this.history, JSON.stringify(this.scene)].slice(-10);
      this.preHistory = [];
      this.$set(this.scene.nodes, maxID, template);
    },
    addNode(e) {
      const x = arguments[1] - this.scene.centerX;
      const y = arguments[2] - this.scene.centerY;
      console.log("nodeX", x);
      console.log("nodeY", y);

      const maxID = Number(new Date().getTime());
      let template = {};

      // AIModels  填入流程

      if (this.newNodeType === "AIModels") {
        const label = this.newNodeKey;
        const classList = Object.entries(this.exportKnnDataSet[label]).map(el => el[1].name);
        const outputOfPortStyle = [];
        const outputCount = classList.length;
        const outputsOfProperty = {};
        const aiProps = [];
        classList.forEach((el, idx) => {
          outputOfPortStyle.push([0, 0]);
          outputsOfProperty[`output${idx + 1}`] = 0;
          aiProps.push({
            name: el,
            confidence: 0
          });
        });
        template = {
          type: "AIModels",
          label,
          styleClass: {
            firstClass: "AIModels",
            secondClass: "special"
          },
          portStyle: {
            input: [[0, 0]],
            output: outputOfPortStyle
          },
          properties: {
            value: 0,
            inputCount: 1,
            outputCount,
            inputs: {
              input1: 0
            },
            outputs: outputsOfProperty,

            aiProps
          }
        };
      } else if (this.newNodeType === "Actions") {
        const index = this.newNodeIndex;
        console.log("index index", index);
        const { name, code } = this.cacheDFDActions.actions[index];

        template = {
          type: "Actions",
          label: "動作",
          styleClass: {
            firstClass: "Actions",
            secondClass: "special"
          },
          portStyle: {
            input: [[0, 0]],
            output: [[0, 0]]
          },
          properties: {
            value: 0,
            inputCount: 1,
            outputCount: 1,
            inputs: {
              input1: 0
            },
            outputs: {
              output1: 0
            },
            actionsProp: {
              name,
              ble: {},
              code
            }
          }
        };
      } else {
        template = JSON.parse(JSON.stringify(this.nodeDefinitions.nodeTemplates[this.newNodeType]));
      }
      console.log(template);

      template.id = maxID;
      template.x = x;
      template.y = y;
      this.history = [...this.history, JSON.stringify(this.scene)].slice(-10);
      this.preHistory = [];
      this.$set(this.scene.nodes, maxID, template);
    },
    nodeClick(key, value) {
      console.log("node click", key, value);
      this.nodeSelected = [key];
    },
    nodeUnselected() {
      this.nodeSelected = [];
    },
    nodeDelete(temp) {
      this.history = [...this.history, JSON.stringify(this.scene)].slice(-10);
      this.preHistory = [];
      console.log("node delete", temp);
    },
    linkBreak(id) {
      this.history = [...this.history, JSON.stringify(this.scene)].slice(-10);
      this.preHistory = [];
      console.log("link break", id);
    },
    linkAdded(link) {
      this.history = [...this.history, JSON.stringify(this.scene)].slice(-10);
      this.preHistory = [];
      console.log("new link added:", link);
    },
    changeInputCountByOperator(id) {
      console.log("changeInputCountByOperator", id);
      this.settingNodeKey = id;
      // if 現在的inputCount多餘 應有的 max
      // 減到剩下max
      const theNode = this.scene.nodes[this.settingNodeKey];
      const { inputCount } = theNode.properties;
      let maxInputCount = 0;
      let minInputCount = 0;

      if (theNode.styleClass.firstClass === "Constant") {
        minInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass]
          .special[0];
        maxInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass]
          .special[1];
      } else {
        minInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass][
          theNode.styleClass.secondClass
        ][0];
        maxInputCount = this.nodeDefinitions.nodeInputCountMap[theNode.styleClass.firstClass][
          theNode.styleClass.secondClass
        ][1];
      }

      if (inputCount > maxInputCount) {
        this.scene.nodes[this.settingNodeKey].properties.inputCount = maxInputCount;
      } else if (minInputCount > inputCount) {
        this.scene.nodes[this.settingNodeKey].properties.inputCount = minInputCount;
      }
    },
    openEditNodePanel(id) {
      console.log("openEditNodePanel", id);
      this.settingNodeKey = id;

      this.showShadowMask = this.scene.nodes[this.settingNodeKey].styleClass.firstClass;
      console.log("this.showShadowMask", this.showShadowMask);
    },
    closeShadowMask(val, force = false) {
      this.showShadowMask = "";
      if (val === "manager") {
        this.ticktokControllerManager++;
      } else if (val === "ble") {
        console.log("stopScan");
        bleHandler.stopScan();
      } else if (val === "play" && force) {
        this.ticktokControllerPlay++;
      }
    },

    minusInputCount() {
      console.log("minusInputCount");
      if (this.canMinusNodeCount) {
        this.scene.nodes[this.settingNodeKey].properties.inputCount--;
      }
    },
    plusInputCount() {
      if (this.canPlusNodeCount) {
        this.scene.nodes[this.settingNodeKey].properties.inputCount++;
      }
    },
    openDropDown() {
      this.showDropDown = !this.showDropDown;
    },
    changeCounterOption(option) {
      this.scene.nodes[this.settingNodeKey].styleClass.secondClass = option;
    },
    resetBlockValue() {
      console.log("scene", this.scene);

      for (const nodeKey in this.scene.nodes) {
        const node = this.scene.nodes[nodeKey];
        const { properties, type } = node;
        const { inputs, outputs } = properties;
        if (type !== "Constant") {
          // Constant 的value 不還原成0 其餘都還原
          properties.value = 0;
        }
        for (const key in inputs) {
          // 還原成0
          inputs[key] = 0;
        }
        for (const key in outputs) {
          // 還原成0
          outputs[key] = 0;
        }
      }
    },
    clearAllBtnWithConfirm() {
      swalWithCustomClass
        .fire({
          title: "Clear All",
          text: "Are you sure to clear all block diagram?",
          reverseButtons: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.clearAllBtn();
          }
        });
    },
    clearAllBtn() {
      this.clearAll = true;
      this.scene.links = [];
      this.scene.nodes = {};
      this.scene.centerX = 971;
      this.scene.centerY = 727;
      this.scene.transformX = 0;
      this.scene.transformY = 0;
      this.scene.scale = 1;
      this.cacheDFDActionsData({});
    },
    resetClearAll() {
      this.clearAll = false;
    },
    async checkCodeID() {
      const codeID = this.cacheDFDActions.codeID;
      // const codeID = "1234";
      const BLEsStatus = {};
      let isBLEsReady = true;
      console.log(`燒錄的codeID是 ${codeID}`);

      const tmpDevice = [];
      Object.keys(this.connectedDevices).forEach(device => {
        tmpDevice.push(this.connectedDevices[device]);
      });
      for (let i = 0; i < tmpDevice.length; i++) {
        const deviceCodeId = await this.sendRawDataToDeviceAndWaitForRes(0, tmpDevice[i], 1500);
        const macKey = tmpDevice[i].name;
        const codeChanged = deviceCodeId !== codeID;
        if (codeChanged) {
          isBLEsReady = false;
        }
        console.log(`${macKey}這一台的codeID是 ${deviceCodeId}`);
        BLEsStatus[macKey] = { codeChanged };
      }
      const result = {
        isBLEsReady,
        BLEsStatus,
        nowCodeID: codeID
      };
      return result;
    },

    async triggerController(val) {
      console.log("triggerController", val);
      const key = val;
      const valList = ["manager", "variable_manager", "show_value", "camera", "play", "stop"];

      switch (key) {
        case "manager": {
          this.openControllerPanel(key);
          break;
        }
        case "variable_manager": {
          console.log("variable_manager 先不做");

          break;
        }
        case "play": {
          const codeidCompare = await this.checkCodeID();

          /**
           * 按下play後流程
           * 依據 isBLEsReady決定是否走burning
           * 1. execute 直接執行
           * 2. 先burning 成功後=>再做execute  (走燒錄流程)
           */
          if (codeidCompare.isBLEsReady) {
            console.log("isBLEsReady");
            this.closeShadowMask("play");
            this.resetBFS();
            await this.execute();
          } else {
            console.log("isBLEsReady  NOT");
            console.log(codeidCompare);
            this.openControllerPanel(key);
            this.burning(codeidCompare);
            // if (await this.burning(codeidCompare, `${targetPathAction}/action.hex`)) {
            //   await this.execute();
            // }
          }
          break;
        }
        case "stop": {
          this.stopManually = true;
          break;
        }

        default:
          break;
      }
    },
    changeBuringPercentage(data) {
      console.log("percentage", data, this.burnPercentage);
      this.$set(this.burnPercentage, data.name, data.value);
    },
    async burning(codeidCompare) {
      const { BLEsStatus } = codeidCompare;
      const vm = this;
      const needBurn = [];
      const noNeedBurn = [];
      Object.keys(BLEsStatus).forEach(key => {
        if (BLEsStatus[key].codeChanged) {
          needBurn.push(key);
        } else {
          noNeedBurn.push(key);
        }
      });
      noNeedBurn.forEach(key => {
        this.burnPercentage[key] = 100;
      });
      const promises = [];
      needBurn.forEach(async el => {
        console.log(`upload ${el}`);
        promises.push(this.uploadFW(this.connectedDevices[el], this.cacheDFDActions.hex));
      });
      // this.closeShadowMask("play");
      const delay = () =>
        new Promise(resolve => {
          setTimeout(resolve, 5000);
        });

      await Promise.all(promises)
        .then(result => {
          console.log(result);
          // wait for ble reconnect
          return delay();
        })
        .then(() => {
          console.log("after 5 decs");
          this.triggerController("play");
        })
        .catch(err => {
          console.log("some err happen...", err);
        });
    },
    interruptBurning() {
      // tell the burning funtion to stop after this round;
      this.interrupter = true;
      console.log("it will stop after this round!");
    },
    openControllerPanel(key) {
      console.log("openControllerPanel", key);
      this.showShadowMask = key;
      console.log("this.showShadowMask", this.showShadowMask);
    },
    changeNickName(item, e) {
      console.log("changeNickName", item, e);

      if (e.target.value.length === 0 || e.target.value.length > 8) {
        alert("The length of NickName must be between 1 and 8");
      } else {
        this.changeDeviceNickName({ name: item.name, nickName: e.target.value });
      }
    },
    rasFlipChange() {
      let fileList = this.$refs.inputs.files;
      let promises = [];
      console.log(fileList);
      for (let i = 0; i < fileList.length; i++) {
        let filePromise = new Promise(resolve => {
          let reader = new FileReader();
          reader.readAsText(fileList[i]);
          reader.onload = event => {
            let name = fileList[i].name
              .split("\\")
              .pop()
              .split(".")[0]
              .split(/\W/gm)
              .join("");
            let dataParsed = JSON.parse(event.target.result);
            let res = "";
            if (dataParsed.hasOwnProperty("timelineData")) {
              res = this.rasParse(name, dataParsed.timelineData);
              resolve(res);
            } else {
              reject("Include not Ras file");
            }
          };
        });
        promises.push(filePromise);
      }
      Promise.all(promises)
        .then(result => {
          console.log(result);
          let allFuncs = [
            ...result,
            "void transArray(byte tmp1, byte tmp2, byte tmp3, byte tmp4, byte tmp5, byte tmp6, byte tmp7, byte tmp8, byte *p){\nbyte tmpArray[8] = {tmp1, tmp2, tmp3, tmp4, tmp5, tmp6, tmp7, tmp8};for(int i=0;i<8;i++)p[i]=tmpArray[i];}"
          ];
          this.generateActionComponent(allFuncs, [], []);
        })
        .catch(err => {
          console.log(err);
        });
    },
    async generateActionComponent(funcs, vars, imports) {
      this.showShadowMask = "window";

      let newFunctionArray = this.addFunc(funcs, vars, imports);

      for (const node in this.scene.nodes) {
        console.log("me", this.scene.nodes[node]);
        let { type, id } = this.scene.nodes[node];
        if (type === "Actions") {
          this.$refs["simpleFlowChart"].nodeDelete(id);
        }
      }
      await this.createCode()
        .then(result => {
          if (result.sucess) {
            console.log(result.hex === this.hexData);
            this.cacheDFDActionsData({
              actions: newFunctionArray,
              vars,
              hex: this.hexData,
              codeID: this.getCodeID()
            });
            window.localStorage.setItem("cacheActionsData", JSON.stringify(this.cacheDFDActions));
          } else {
            return new Error("compile error ");
          }
        })
        .catch(err => {
          console.log("compile error, using default project");
        });
      this.showShadowMask = "";
    },
    codeFileChange() {
      const reader = new FileReader();
      reader.onload = event => {
        if (event.target.result.length > 0) {
          // const result = JSON.parse(event.target.result);
          this.parseCode(event.target.result);
        }
      };
      reader.readAsText(this.$refs.input.files[0]);
    },
    async parseCode(code) {
      let dataParsed = JSON.parse(code);
      if (!dataParsed.hasOwnProperty("code")) {
        console.log("Notice", "Not Code file");
        return;
      }

      const codeToScan = dataParsed.code;
      console.log(codeToScan);
      const functions = codeToScan.match(/void\s.*\{(.|\r|\n)*?\}(\r|\n){2}/gm) || [];
      const variables = codeToScan.match(/(\r|\n)int\s.*/gm) || [];
      const imports = codeToScan.match(/FR_LEDRing ledRing_port_\d\(A\d\);/) || [];
      console.log(functions, variables, imports.slice(0));
      this.generateActionComponent(functions, variables, imports.slice(0));
    },

    async addAction() {
      await this.triggerController("stop");
      console.log("addAction");
      this.$refs.input.click();
      // let interval = null;
      // const vm = this;
    },
    async addActions() {
      await this.triggerController("stop");
      console.log("addActions");
      this.$refs.inputs.click();
    }
  }
};
</script>
<style lang="scss">
.custom-confirm {
  background: rgba(0, 0, 0, 0.8) !important;
  .swal2-popup {
    width: 380px;
  }
  .swal2-modal {
    font-family: Arial;

    background-color: #f3f5f9;
    padding: 0;
    border-radius: 10px;
    overflow: hidden;

    .swal2-actions {
      justify-content: flex-end;
    }

    .swal2-header {
      position: relative;
      height: 35px;
      line-height: 35px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      .swal2-title {
        margin-bottom: 0;
        font-size: 13px;
        color: #282828;
        height: 35px;
        line-height: 35px;
      }
      .swal2-close {
        height: 35px;
        width: 35px;
        line-height: 35px;
        &:hover {
          color: #39e2cf;
        }
      }
    }

    .swal2-content {
      padding: 20px 15px;
      font-size: 16px;
      text-align: left;
      color: #282828;
    }
    .swal2-actions {
      margin-bottom: 33px;
      margin-top: 0px;
      height: 36px;
      display: flex;
    }

    .button-confirm,
    .button-cancel {
      padding: 0;
      color: white;
      width: 105px;
      height: 35px;
      align-items: center;
      font-size: 20px;
      border: none;

      &:hover {
        color: white;
      }
    }

    .button-confirm {
      background-color: #37ccda;

      width: 50%;
      &:hover {
        background-image: linear-gradient(to right, #23cfbb 0%, #2a9ec9);
      }
      &:focus {
        color: white;
        outline: none !important;
        box-shadow: none !important;
      }
    }
    .button-cancel {
      background-color: #9b9c9e;
      color: #282828;

      width: 50%;

      &:hover {
        background-color: #b3b4b5;
        color: #ffffff;
        border: solid 1px #999999;
      }
      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.mainDiv {
  position: absolute;
  top: 160px;
  width: 100vw;
  bottom: 0px;
  display: flex;
  min-height: 500px;
  .area {
    display: flex;
    padding: 37px 0px 30px 0px;
    align-items: center;
    flex-direction: column;
  }
  .flowchartArea {
    flex-grow: 1;
    background-color: #000000;
    position: relative;
    overflow: hidden;
  }
  .toolsArea {
    flex-basis: 260px;
    background-color: #ffffff;
    padding: 0px 15px;
    position: relative;
    &::after {
      content: " ";
      width: 2px;
      background-color: transparent;
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
    }
    .toolBlock {
      height: 24%;
      display: flex;
      flex-direction: column;
      position: relative;
      .titleWithBtn {
        display: flex;
        height: 20px;
        margin: 10px 0px 16px;
        align-items: center;
        justify-content: space-around;
      }
      .title {
        font-size: 20px;
        color: #282828;
      }
      .addBUtton {
        cursor: pointer;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.16);
        border-radius: 5px;
        width: 75px;
        height: 26px;
        line-height: 26px;
        &:hover {
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
        }
        svg {
          position: relative;
          left: -5px;
        }
        span {
          color: #707070;
          font-size: 14px;
        }
      }
      p {
        font-size: 20px;
        color: #282828;
        text-align: left;
        margin-top: 10px;
      }
      .img_container {
        display: flex;
        justify-content: flex-start;
        border-radius: 5px;
        flex-wrap: wrap;
        border-top: 3px solid #dadde1;
        border-bottom: 3px solid #dadde1;
        border-left: 3px solid #dadde1;
        overflow-y: scroll;
        flex-grow: 1;
        .action {
          cursor: pointer;
          height: 35px;
          padding: 0px 5px;
          line-height: 35px;
          border-radius: 5px;
          text-align: center;
          font-size: 15px;
          background-color: #9b9c9e;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 5px;
        }
        .AIModel {
          height: 65px;
          width: 59px;
          background-color: transparent;
          .block {
            height: 35px;
            width: 35px;
            background-color: #282828;
            border-radius: 5px;
            margin: 5px 12px;
          }
          p {
            font-size: 12px;
            color: #282828;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 59px;
            height: 12px;
            padding: 5px;
            line-height: 0px;
            text-align: center;
          }
        }
        &::-webkit-scrollbar-corner {
          background: white;
        }

        &::-webkit-scrollbar-track {
          background: #dadde1;
        }
        &::-webkit-scrollbar {
          width: 10px !important;
        }
        &::-webkit-scrollbar-thumb {
          background: #9b9c9e;
          border-radius: 6px;
          // border: 5px solid transparent;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        img {
          padding: 5px;
        }
      }
    }
  }
}
$blue: #6eb6d6;

.chartController {
  position: absolute;
  right: 5px;
  bottom: 0;
  max-width: 80px;
}

#chart {
  min-height: 100vh;
  background-color: white;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  height: 100%;
  line-height: 1.5;
  overflow: hidden;
  .tool-wrapper {
    position: relative;
    .tool-block {
      margin-top: 10px;
      text-align: start;
      font-size: 12px;
      color: #707070;
      .addBUtton {
        cursor: pointer;
        margin-left: 8px;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.16);
        border-radius: 5px;
        display: inline-block;
        width: 75px;
        height: 26px;
        line-height: 32px;
        &:hover {
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
        }
        svg {
          top: -3px;
          left: 3px;
          position: relative;
        }
        span {
          left: 11px;
          top: -2px;
          display: inline-block;
          position: relative;
        }
      }

      &:nth-of-type(1),
      &:nth-of-type(2) {
        .scroll-block {
          height: 184px;
        }
      }
      &:nth-of-type(3) {
        .scroll-block {
          height: 138px;
        }
      }
      &:nth-of-type(4) {
        .scroll-block {
          height: 142px;
        }
      }
      .title {
        font-size: 20px;
        color: #282828;
      }
      .scroll-block {
        box-sizing: border-box;
        width: 230px;
        border-radius: 5px;
        border-top: solid 3px #dadde1;
        border-bottom: solid 3px #dadde1;
        border-left: solid 3px #dadde1;
        overflow-y: scroll;
        padding: 10px;
        margin-top: 5px;

        &::-webkit-scrollbar-corner {
          background: white;
        }

        &::-webkit-scrollbar-track {
          background: #dadde1;
        }
        &::-webkit-scrollbar {
          width: 10px !important;
        }
        &::-webkit-scrollbar-thumb {
          background: #9b9c9e;
          border-radius: 6px;
          // border: 5px solid transparent;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        img {
          cursor: pointer;
          margin-right: 8px;
          margin-bottom: 10px;
        }
        .ai {
          position: relative;
          &:after {
            font-size: 12px;
            left: -4.5px;
            bottom: 4px;
            width: 50px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: absolute;
            content: attr(data-text);
            color: black;
          }
          .ai-img {
            cursor: pointer;
            margin-right: 23px;
            margin-bottom: 25px;
          }
        }
        .action {
          cursor: pointer;
          margin-right: 8px;
          margin-bottom: 10px;
          height: 35px;
          width: 60px;
          line-height: 35px;
          color: white;
          border-radius: 5px;
          box-sizing: border-box;
          padding-left: 10px;
          padding-right: 10px;
          text-align: center;
          font-size: 15px;
          background-color: #9b9c9e;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

#shadowMask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
}

.editNodePanel {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // overflow: hidden;
  border-radius: 10px;
  background: #f3f5f9;
  box-shadow: 0 4px 23px 5px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.15);
  color: #333333;
  min-width: 303px;
  padding: 0;
  z-index: 1000;
  header {
    height: 35px;
    line-height: 35px;
    text-align: center;
    position: relative;
    background-color: #ffffff;
    overflow: hidden;
    margin: 0;
    font-size: 14px;

    border-radius: 10px 10px 0 0;
    box-shadow: 0.2px 0.2px 4px 1px rgba(0, 0, 0, 0.1);
    img {
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .setting-container {
    font-size: 14px;
    background-color: #f3f5f9;
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
    border-radius: 10px;
  }
  .setting-content {
    display: inline-block;
    span {
      margin-right: 10px;
      font-size: 16px;
    }
    img {
      cursor: pointer;
    }
    img:first-of-type {
      margin-right: 8px;
    }
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input {
      margin-right: 8px;
      border-radius: 5px;
      border: solid 1px #37ccda;
      text-align: center;
      font-size: 16px;
      line-height: 35px;
      padding-top: 0;
      padding-bottom: 0;
      height: 35px;
      width: 45px;

      &[type="number"][disabled] {
        background-color: white;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .show-zone {
    cursor: default;
    padding-left: 10px;
    padding-right: 25px;
    position: relative;
    height: 30px;
    line-height: 30px;
    background-color: white;
    border-radius: 5px;
    display: inline-block;
    border: 1px $blue solid;
    .arrow {
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid $blue;
      z-index: 99;
    }
  }

  .expand-zone {
    position: absolute;
    left: 0;
    background-color: white;
    border: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.16);
    margin-top: -1px;
    width: 100%;
    z-index: 99999;

    .custom-option {
      display: inline-block;
      cursor: pointer;
      padding-left: 10px;
      text-align: start;
      height: 27px;
      width: 100%;

      &:hover {
        background-color: $blue;
        color: white;
      }
    }
  }
}

.editManagerPanel {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
  background: #f3f5f9;
  box-shadow: 0 4px 23px 5px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.15);
  color: #333333;
  min-width: 303px;
  padding: 0;
  z-index: 1000;
  header {
    height: 35px;
    line-height: 35px;
    text-align: center;
    position: relative;
    background-color: #ffffff;
    overflow: hidden;
    margin: 0;
    font-size: 13px;
    border-radius: 10px 10px 0 0;
    box-shadow: 0.2px 0.2px 4px 1px rgba(0, 0, 0, 0.1);
    img {
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .footer {
    padding: 15px;
    background-color: #f3f5f9;
  }
  .content {
    font-size: 14px;
    background-color: #f3f5f9;
    text-align: left;
    line-height: 1.5;
    padding: 20px;
    padding-bottom: 0;
    ul {
      margin-bottom: 0;
    }
    li:first-of-type {
      margin-top: 0;
    }
    li {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-top: 20px;
      &.error {
        color: red !important;
      }
    }

    h3 {
      margin-bottom: 0;
      font-size: 14px;
      line-height: 35px;
      width: 100px;
      overflow: hidden;
      position: relative;
    }

    input {
      height: 35px;

      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      border-radius: 5px;
      border: 1px solid #37ccda;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 10px;
      height: 30px;

      &[disabled] {
        background-color: #fff;
        border: 1px solid #9b9c9e;
      }

      &:focus {
        outline: none;
      }
    }

    .progress {
      margin-top: 10px;
    }

    img {
      height: 17px;
      width: 21px;
      align-self: center;
      margin-left: 20px;
      margin-right: 20px;
    }
  }
}

.windowLoading {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 175px;
  height: 100px;
  z-index: 1000;

  transform: translate(-50%, -50%);
  span {
    display: block;
    background: #35b6e6;
    width: 7px;
    height: 10%;
    border-radius: 14px;
    margin-right: 5px;
    float: left;
    margin-top: 25%;
    &:last-child {
      margin-right: 0px;
    }
    &:nth-child(1) {
      animation: load 2.5s 1.4s infinite linear;
    }
    &:nth-child(2) {
      animation: load 2.5s 1.2s infinite linear;
    }
    &:nth-child(3) {
      animation: load 2.5s 1s infinite linear;
    }
    &:nth-child(4) {
      animation: load 2.5s 0.8s infinite linear;
    }
    &:nth-child(5) {
      animation: load 2.5s 0.6s infinite linear;
    }
    &:nth-child(6) {
      animation: load 2.5s 0.4s infinite linear;
    }
    &:nth-child(7) {
      animation: load 2.5s 0.2s infinite linear;
    }
    &:nth-child(8) {
      animation: load 2.5s 0s infinite linear;
    }
    &:nth-child(9) {
      animation: load 2.5s 0.2s infinite linear;
    }
    &:nth-child(10) {
      animation: load 2.5s 0.4s infinite linear;
    }
    &:nth-child(11) {
      animation: load 2.5s 0.6s infinite linear;
    }
    &:nth-child(12) {
      animation: load 2.5s 0.8s infinite linear;
    }
    &:nth-child(13) {
      animation: load 2.5s 1s infinite linear;
    }
    &:nth-child(14) {
      animation: load 2.5s 1.2s infinite linear;
    }
    &:nth-child(15) {
      animation: load 2.5s 1.4s infinite linear;
    }
  }
}

@keyframes load {
  0% {
    background: #35b6e6;
    margin-top: 25%;
    height: 10%;
  }
  50% {
    background: #39e2cf;
    height: 100%;
    margin-top: 0%;
  }
  100% {
    background: #35b6e6;
    height: 10%;
    margin-top: 25%;
  }
}
</style>
